import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'vectronic-formly-form-group-panel',
  imports: [],
  template: `
    <div class="form-group">
      @if (props?.label) {
        <h3 class="form-group__header">{{ props.label }}</h3>
      }
      <div class="form-group__body">
        <ng-container #fieldComponent></ng-container>
      </div>
    </div>
  `,
  styles: ['.form-group__body {padding-left: 1rem}', '.form-group__header {margin-bottom: 1rem}'],
})
export class FormlyFormGroupWrapperComponent extends FieldWrapper {}
